var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplymintGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 261,
    viewBox: "0 0 285 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.922,
    y: 36.2656,
    width: 17.7257,
    height: 94.5371,
    fill: "#B7B2B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 156.781,
    transform: "matrix(0.618197 0.786023 -0.786022 0.618198 130.352 22.2266)",
    fill: "#B7B2B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 131.713,
    transform: "matrix(0.837757 0.546044 -0.546042 0.837758 133.938 133.977)",
    fill: "#B7B2B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 131.713,
    transform: "matrix(0.908472 -0.417945 0.417944 0.908473 10.5156 133.656)",
    fill: "#B7B2B2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 124.12,
    transform: "matrix(0.887287 0.461218 -0.461217 0.887287 259 125.734)",
    fill: "#B7B2B2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 229.326,
    transform: "matrix(0.465497 -0.885049 0.885049 0.465499 6.1875 141.492)",
    fill: "#B7B2B2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 17.7257,
    height: 231.189,
    transform: "matrix(0.455382 0.890296 -0.890296 0.455383 269.695 130.227)",
    fill: "#B7B2B2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.72,
    cy: 24.4702,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.72,
    cy: 130.837,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.517,
    cy: 130.837,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.7827,
    cy: 237.205,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.837,
    cy: 130.837,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.572,
    cy: 237.205,
    rx: 23.6342,
    ry: 23.6343,
    fill: "#B7B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplymintGrey);
export default __webpack_public_path__ + "static/media/supplymintGrey.30392b16344171d480196e6a43e6f3f0.svg";
export { ForwardRef as ReactComponent };